import { EPublishTermsStatus } from '../../../../types/reducers/publishTerms';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectPublishTermsStatus } from '../../../../selectors/publishTerms';

interface IServicePickerWidgetStatusProps {
  statusToComponent: Record<EPublishTermsStatus, React.ReactElement>;
}

export const ServicePickerWidgetStatus = ({ statusToComponent }: IServicePickerWidgetStatusProps) => {
  const status = useSelector(selectPublishTermsStatus);

  return statusToComponent[status];
};
